module.exports = __webpack_public_path__ + "file_attachment_128.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/file_attachment_128.png
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/file_attachment_128.png
// module chunks = 10